/**
 * @desc 更新walmart历史订单行数据
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/walmart/selectSpItemNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
